import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import '../../services/GlobalVariables';

const API_URL = global.SET_API_URL + 'openingClosing/';

// Thunks
export const createOpening = createAsyncThunk(
  'opening/createOpening',
  async (openingData, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'opening/create', openingData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getTodayOpening = createAsyncThunk(
  'opening/getTodayOpening',
  async (payload, { rejectWithValue }) => {
    try {
      console.log(API_URL + 'opening/today')
      const response = await axios.post(API_URL + 'opening/today', payload);
      console.log('Response from getTodayOpening:', response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial State
const initialState = {
  data: null,
  loading: false,
  error: null,
  success: false
};

// Slice
const openingSlice = createSlice({
  name: 'opening',
  initialState,
  reducers: {
    clearOpening: (state) => {
      state.data = null;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    // createOpening
    builder
      .addCase(createOpening.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createOpening.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.success = true;
      })
      .addCase(createOpening.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    // getTodayOpening
    builder
      .addCase(getTodayOpening.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTodayOpening.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(getTodayOpening.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      });
  }
});

export const { clearOpening } = openingSlice.actions;
export default openingSlice.reducer;
